import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "../index.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


toast.configure();
function LoginForm() {
  const [details, setDetails] = useState({ username: "", password: "" });
  const history = useHistory();
  const recap = false;
  const [error, setError] = useState(null);
  const Login = (details) => {
    fetch(`${localStorage.getItem("url")}/api/login/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(details),
    })
      .then((data) => {
        if (!data.ok) {
          throw Error("Dados de acesso invalidos");
        }
        return data.json();
      })
      .then((data) => {
        localStorage.setItem("token", data.token);
        localStorage.setItem("username", details.username);
        toast.success(`Bem vindo(a) ${details.username}`);
        console.log(data)

        if (data.grupo == "Operario") {
          localStorage.setItem("log", true);
          localStorage.setItem("nivel", "operador");
          history.push("/home");
        }
        if (data.grupo == "Director") {
          localStorage.setItem("log", true);
          localStorage.setItem("nivel", "contabilidade");
          history.push("/admin/home");
        }
        if (data.grupo == "Contabilidade") {
          localStorage.setItem("log", true);
          localStorage.setItem("nivel", "contabilidade");
          history.push("/cont/home");
        }
        if (data.grupo=="recargatest"){
          localStorage.setItem("log", true);
          localStorage.setItem("nivel", "contabilidade");
          history.push("/test/home");    
      }}
      )
      .catch((e) => {
        setError(e.message);
        toast.error(`Credenciais invalidas! verifique o nome ou palavra passe`);
      });
  };
  const submitHandler = (e) => {
    e.preventDefault();
    Login(details);
  };
  const onChange = (value) => {
    console.log("Captcha value:", value);
    recap = !recap;
  };
  return (
    <form className="login" onSubmit={submitHandler}>
      {localStorage.setItem("url", "http://172.104.143.46")}

      {localStorage.setItem("log", false)}
      <div className="form-inner">
                
                <div className='top'>
                 <img   className='imagem_logo' src={require("./images/ENH.png")} />
              
                </div>
                <div className="form-group">
                    <input type="text" name="username" id="username" placeholder='Nome do usuario'  onChange={e => setDetails({ ...details, username: e.target.value })}   value={details.username} required />

                </div>
                <div className="form-group">
                    <input type="password" name="password" id="password" placeholder='Senha' onChange={e => setDetails({ ...details, password: e.target.value })} value={details.password} required/>
                   
                </div>
             
                <input  type="submit"  id = "Geeks" name="myGeeks" value="iniciar sessão" disabled={recap}/>


                <div>
                    
                </div>

            </div>
    </form>
  );
}

export default LoginForm;
